<app-filter-option
  icon="/assets/icons/componentTypes.svg"
  [title]="'FILTER.TYPE.TITLE' | translate"
  (apply)="onApply()"
  (back)="onBack()"
>
  <app-multi-checkbox [optionArray]="typeOptions" (optionChange)="onOptionChange($event)"></app-multi-checkbox>
</app-filter-option>
